import { useIntl } from "react-intl";

import { HeaderSearchButton } from "@/components/HeaderSearchButton/HeaderSearchButton";
import { StickyHeader } from "@/components/StickyHeader/StickyHeader";
import { useHotelSearchDataContext } from "@/features/hotels/contexts/HotelSearchDataContext";
import type { HotelData } from "@/features/hotels/types/types";
import { getTotalVisitors } from "@/features/hotels/utils/rooms";
import { formatHeaderDate } from "@/utils/dates";

type HotelDetailHeaderProps = {
  hotel: HotelData;
  onSearchDrawerOpen: () => void;
};

export function HotelDetailHeader({
  hotel,
  onSearchDrawerOpen,
}: HotelDetailHeaderProps) {
  const { searchData } = useHotelSearchDataContext();
  const intl = useIntl();

  if (!searchData) return null;

  return (
    <StickyHeader>
      <div className="flex items-center justify-between gap-2 py-2 text-text-primary">
        <div className="grow overflow-hidden">
          <HeaderSearchButton onClick={onSearchDrawerOpen}>
            <h3 className="w-full truncate text-start font-medium text-text-title">
              {hotel.name}
            </h3>

            <div className="w-full truncate text-xs font-normal text-text-tertiary">
              {[
                `${formatHeaderDate(searchData.dates.checkIn)} - ${formatHeaderDate(searchData.dates.checkOut)}`,
                intl.formatMessage(
                  {
                    defaultMessage:
                      "{count, plural, one {# traveller} other {# travellers}}",
                    description: "Traveller count summary label",
                  },
                  { count: getTotalVisitors(searchData.rooms) },
                ),
                intl.formatMessage(
                  {
                    defaultMessage:
                      "{count, plural, one {# room} other {# rooms}}",
                    description: "Room count summary label",
                  },
                  { count: searchData.rooms.length },
                ),
              ].map((item, index) => (
                <span key={index}>
                  {index > 0 ? <> &bull; </> : null}
                  {item}
                </span>
              ))}
            </div>
          </HeaderSearchButton>
        </div>
      </div>
    </StickyHeader>
  );
}
